import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Toast, Dialog } from 'antd-mobile';
import { formatSeconds } from "../../../../utils/date";
import api from "../../../../api";
import "./style.less";

const OrderProgressEnum = {
  1: '待支付',  // 已创建
  2: '已支付',
  3: '充电中',
  4: '已退款',
  5: '已完成',
  6: '已取消',
  7: '已完成', // 部分退款
};

const PayChannelEnum = {
  1: '微信',
  2: '支付宝',
  3: '会员卡',
  4: 'IC卡',
};

const ListOrderView = (props) => {
  const { order, canClick } = props
  const navigate = useNavigate()

  // 点击订单信息，跳转到
  const handleClickCard = () => {
    // 未支付时，点击卡片跳转到支付页面
    if ((order.progress === 1) && canClick) {
      navigate(`/order/${order.id}/pay`)
    } else if (order.progress === 3 || order.progress === 4 || order.progress === 5 || order.progress === 7) {
      navigate(`/order/${order.id}/power/list`)
    }
  }

  // 提前结束订单
  const stopOrder = (e) => {
    e.preventDefault()
    e.stopPropagation()

    Dialog.confirm({
      content: '提前结束充电，有损伤电池风险',
      confirmText: '提前结束',
      cancelText: '继续充',
      onConfirm: async () => {
        const orderId = order.id;
        api.userOrderStop({ orderId }).then((res) => {
          const data = res.data
          if (!data) {
            return
          }
          if (data.code !== 0) {
            Toast.show({
              icon: 'fail',
              content: data.message,
              position: 'center'
            })
            return
          }
          Toast.show({
            content: '指令已下达，请稍后刷新订单列表查看。',
            position: 'center',
          })
        });
      },
    });
  }

  let progress = OrderProgressEnum[order.progress]
  if (order.progress === 1) {
    // 计算剩余时间 - iOS不支持 '2022-08-11 12:13:56' 的时间格式
    const createdDate = order.createdDate.replace(/-/g, '/')
    const ct = Date.parse(createdDate)
    const now = Date.now()
    const dv = ct + 60 * 2 * 1000 - now;

    if (dv <= 0) {
      progress = '支付超时';
    }
  }

  let payChannel = PayChannelEnum[order.payChannel];

  let chargeTime = 0;
  if (order.progress === 3 && order.startTime) {
    const startTime = order.startTime.replace(/-/g, '/')
    const st = Date.parse(startTime)
    const now = Date.now()
    chargeTime = (now - st) / 1000;
  } else if (order.endTime && order.startTime) {
    const startTime = order.startTime.replace(/-/g, '/')
    const st = Date.parse(startTime)
    const endTime = order.endTime.replace(/-/g, '/')
    const et = Date.parse(endTime)
    chargeTime = (et - st) / 1000;
  }
  let chargeTimeFormat = formatSeconds(chargeTime);

  // 超过30分钟可提前结束
  let canStop = false;
  if (order.progress === 3 && chargeTime > 60 * 10) {
    canStop = true;
  }

  return (
    <div className="order-view-wrapper">
      <Card title={progress} onClick={handleClickCard}>
        <p>订单编号：{order.orderNo}</p>
        <p>下单时间：{order.createdDate}</p>
        {
          order.endTime ? <p>结束时间：{order.endTime}</p> : undefined
        }
        <p>设备编号：{order.device?.no}</p>
        <p>充电端口：{order.port?.portNo}</p>
        <p>充电时长：{chargeTime === 0 ? '-' : chargeTimeFormat}</p>
        <p>预付金额：{order.payFee / 100} 元</p>
        {
          order.progress !== 1 ? <p>实际消费：{order.actualFee / 100} 元</p> : undefined
        }
        {
          payChannel ? <p>支付方式：{payChannel}</p> : undefined
        }
        {
          canStop ?
            <Button block color="warning" size='middle' onClick={stopOrder}>关闭充满自停功能，提前停止充电</Button>
            :
            undefined
        }
      </Card>
    </div>
  )
}

export default ListOrderView